import { groupBy } from 'ramda';
import { StringParam, useQueryParam, withDefault } from 'use-query-params';
import { usePcConfigurator } from 'utils/PcConfiguratorContext';
import { BOLT_STEPS, CERTAIN_STEPS, STEPS } from '../constants';
import { STEPS_FOUR_STAGES } from '../constants_four_stages';
import PcModelOptionsGroup from '../PcModelOptionsGroup';
import PcModelOptionsReview from '../PcModelOptionsReview';
import styles from './styles';
import PcModel from '..';
import PcModelPanelPrints from '../PcModelPanelPrints';

const PcModelOptions = ({ modelTheme, setStepUltraLabs, panelPrintImages }) => {
  const { options, subGroups, pcModel, errors } = usePcConfigurator();
  const uid = pcModel.prismic_uid;
  const optionsFourStages = ['build', 'ultra-labs', 'accessories (new)'];
  let isInArray = false;
  let currentStep;
  const hasPanelPrints = Boolean(
    options.find((option) => option.group_type === 'panel_print'),
  );
  let suggestedOptionId; 

  if (hasPanelPrints) {
    suggestedOptionId = pcModel.modelOptionGroup.find((OptionGroup) => OptionGroup?.model_option_group_id === 18688)?.target_upgrade_id;
  }

  let NEWSTEPS;

  if (hasPanelPrints) {
    NEWSTEPS = BOLT_STEPS;
  } else {
    NEWSTEPS = STEPS;
  }

  if (options?.length != 0) {
    isInArray = optionsFourStages.includes(options[0].group_step_new);
    if (isInArray) {
      [currentStep] = useQueryParam(
        'step',
        withDefault(StringParam, STEPS_FOUR_STAGES[0]),
      );
    } else {
      [currentStep] = useQueryParam(
        'step',
        withDefault(StringParam, NEWSTEPS[0]),
      );
    }
  }

  let filteredOptions;

  if (isInArray) {
    filteredOptions = options.filter((option) => {
      if (currentStep == 'ultralabs') {
        setStepUltraLabs(true);
        return option.group_step_new === 'ultra-labs';
      } else if (currentStep == 'accessoriesnew') {
        setStepUltraLabs(false);
        return option.group_step_new === 'accessories (new)';
      } else {
        setStepUltraLabs(false);
        return option.group_step_new === currentStep;
      }
    });
  } else {
    if (currentStep == 'panel_print' && hasPanelPrints) {
      filteredOptions = options.filter(
        (option) => option.group_type === currentStep,
      );
    } else {
      filteredOptions = options.filter(
        (option) => option.group_step_new === currentStep,
      );
    }
  }

  const groupByGroupType = groupBy((item) => item.group_type);
  const optionsByGroupType = groupByGroupType(filteredOptions);
  const groupTypes = Object.keys(optionsByGroupType);

  if (currentStep === 'review') {
    return <PcModelOptionsReview uid={uid} hasPanelPrints={hasPanelPrints} />;
  }

  const orderWithTitle = pcModel.modelOptionGroup.map((item) => ({
    order: item.order || 0,
    title: item.optionGroup.option_group_title,
    groupType: item.optionGroup.option_group_title
      .toLowerCase()
      .replace(/ /g, '_')
      .replace(/-/g, '_')
      .replace(/&/g, 'and')
      .replace(/___/g, '_')
      .replace(/__/g, '_'),
    target_upgrade_id: item.target_upgrade_id,
  }));
  const sortByOrder = orderWithTitle.sort((a, b) => a.order - b.order);
  const newGroupTypesArray = sortByOrder.map((item) => {
    if (groupTypes.includes(item.groupType)) {
      return item;
    }
    return null;
  });

  const panelPrintSubGroups = subGroups.filter(
    (subGroup) =>
      subGroup.group_type === 'panel_print' &&
      subGroup.option_sub_group_id !== 0 &&
      subGroup.option_sub_group_id !== null,
  );

  const newGroupTypes = newGroupTypesArray.filter((item) => item !== null);
  return (
    <>
      {currentStep == 'panel_print' && hasPanelPrints ? (
        <PcModelPanelPrints
          options={filteredOptions}
          panelPrintImages={panelPrintImages}
          panelPrintSubGroups={panelPrintSubGroups}
          suggestedOptionId={suggestedOptionId}
        />
      ) : (
        <div className="pc_model_accordion">
          {newGroupTypes.map((item, k) => (
            <PcModelOptionsGroup
              key={`${item.groupType}_${k}`}
              pcModel={pcModel}
              errors={errors}
              allSubGroups={subGroups}
              groupType={item.groupType}
              target_upgrade_id={item.target_upgrade_id}
              options={options}
              modelTheme={modelTheme}
            />
          ))}
          {/* <PcModelStepsNext /> */}
        </div>
      )}

      <style jsx>{styles}</style>
    </>
  );
};

export default PcModelOptions;
